import { useEffect } from 'react';
import { type Country, getConfig, getConfigByCountry } from '@/constants/config';

const useAppTheme = (country: Country = getConfig().country) => {
  useEffect(() => {
    document.documentElement.dataset.theme = getConfigByCountry(country).theme;
  }, [country]);
};

export default useAppTheme;
